import { requiresAuth, requiresTerms, organizationSeatsGuard } from "@/middleware";

const OrganizationSeatsProductsView = () => import("./OrganizationSeatsProductsView.vue");

const organizationRoutes = [
  {
    path: "/organizations/:organizationId/seats-products/:productId?",
    name: "OrganizationSeatsProducts",
    component: OrganizationSeatsProductsView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, organizationSeatsGuard]
    }
  }
];

export default organizationRoutes;
